import React from 'react'
import { useTranslation } from 'i18n'
import LockIcon from 'images/inline/lock-new.svg'
import { StepSpacingWrapper } from 'components/StepSpacingWrapper/StepSpacingWrapper'
import StepBackground from './StepBackground4'
import './LockedStep.scss'

const LockedStep = ({
  backgroundColor,
  backgroundImageId,
  mobileBackgroundId,
  backgroundImageAlt = '',
  mobileBackgroundImageAlt = '',
  footer,
}) => {
  const { t } = useTranslation('stepShell')
  return (
    <div className="step-locked">
      <StepSpacingWrapper>
        <StepBackground
          backgroundColor={backgroundColor}
          backgroundImageId={backgroundImageId}
          mobileBackgroundId={mobileBackgroundId}
          backgroundImageAlt={backgroundImageAlt}
          mobileBackgroundImageAlt={mobileBackgroundImageAlt}
        />
        <div className="container">
          <div className="content">
            <div>
              <LockIcon />
            </div>
            <h2 className="locked-copy">{t('locked.title')}</h2>
            <p className="locked-subcopy">{t('locked.body')}</p>
          </div>
        </div>
        {footer}
      </StepSpacingWrapper>
    </div>
  )
}

export default LockedStep
